<template>
  <div v-if="showBustaChiusaHeaderActions" class="panoramica-actions">
    <div v-if="bustaChiusaProcessing" class="panoramica-actions-waiting">
      <v-progress-circular
        indeterminate
        :size="12"
        :width="2"
      ></v-progress-circular>
      <span>Assegnazione in corso...</span>
    </div>

    <div
      v-else-if="showEsitoBusteText"
      class="panoramica-actions-esito"
      v-html="bustaChiusaEsitoText"
    ></div>

    <v-menu
      v-if="showBusteOpenedOffers"
      offset-y
      :close-on-content-click="false"
      max-width="360"
    >
      <template #activator="{ on, attrs }">
        <v-badge
          :content="numeroBusteConOfferta"
          color="white text--text"
          overlap
          offset-x="12"
          offset-y="12"
        >
          <v-btn
            rounded
            outlined
            color="white"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small left>receipt_long</v-icon>
            Offerte
          </v-btn>
        </v-badge>
      </template>

      <v-card class="mt-1">
        <v-list dense class="panoramica-buste-menu">
          <v-list-item
            v-for="off in bustaChiusaOfferteOrdinate"
            :key="off.s"
            :class="{
              'panoramica-buste-offerta--top':
                off.o == migliore_offerta.offerta &&
                off.o !== Constants.OFFERTA.PASSO,
            }"
          >
            <v-list-item-avatar size="24">
              <img :src="squadra(off.s).pic" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ off.squadraName }}
              </v-list-item-title>
              <v-list-item-subtitle class="panoramica-buste-offerta-time">
                <template v-if="off.o > Constants.OFFERTA.PASSO">
                  <v-icon x-small class="text--text">schedule</v-icon>
                  <span v-html="bustaChiusaOffertaTime(off.s)"></span>
                </template>
                <template v-else>Nessuna offerta</template>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <crediti
                v-if="off.o !== Constants.OFFERTA.PASSO"
                :crediti="off.o"
                :variant="off.o == migliore_offerta.offerta ? 'dark' : 'light'"
              ></crediti>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <v-btn
      v-if="showAvanti"
      rounded
      color="primary"
      :loading="loading"
      @click="avanti"
    >
      Avanti
    </v-btn>

    <v-btn
      v-else-if="showApriBuste"
      rounded
      color="primary"
      @click="apriBuste"
    >
      Apri buste
    </v-btn>

    <div v-else-if="waitingAdminOpenBuste" class="panoramica-actions-waiting">
      <v-progress-circular
        indeterminate
        :size="12"
        :width="2"
      ></v-progress-circular>
      <span>In attesa che l'admin apra le buste...</span>
    </div>

    <template v-else-if="showOfferActions">
      <v-btn
        rounded
        color="primary"
        @click="showNumpad"
      >
        Offerta
      </v-btn>
      <v-btn
        v-if="roundStep && !roundStep.min_offerta"
        rounded
        color="white"
        class="text--text"
        @click="setPasso(true)"
      >
        Passo
      </v-btn>
      <div
        v-if="showBustaChiusaAutoConfirmHint"
        class="panoramica-busta-hint"
      >
        {{ bustaChiusaAutoConfirmHint }}
      </div>
    </template>

    <div v-else-if="showPassatoHint" class="panoramica-busta-hint">
      {{ bustaChiusaPassoText }}
    </div>

    <div v-if="showWaitingOtherParticipants" class="panoramica-actions-waiting">
      <v-progress-circular
        indeterminate
        :size="12"
        :width="2"
      ></v-progress-circular>
      <span>In attesa degli altri partecipanti...</span>
    </div>
  </div>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import astaBustaChiusaActionsMixin from "../../js/mixins/astaBustaChiusaActionsMixin";
import SquadraOfferta from "./SquadraOfferta";
import Crediti from "./Crediti";

export default {
  name: "asta-busta-chiusa-header-actions",
  mixins: [mixins, astaBustaChiusaActionsMixin],
  components: {
    SquadraOfferta,
    Crediti,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    showBustaChiusaHeaderActions() {
      return (
        this.mode_bustachiusa &&
        (this.active || this.admin) &&
        this.calciatoreInAsta !== null &&
        this.calciatoreInAsta !== undefined &&
        this.running &&
        this.roundStep &&
        [
          Constants.ROUND_STEP.OFFERTE,
          Constants.ROUND_STEP.BUSTE,
        ].includes(this.roundStep.type)
      );
    },
    showAvanti() {
      return (
        !this.bustaChiusaProcessing &&
        this.admin &&
        this.offerteCompletate &&
        this.roundStep.type == Constants.ROUND_STEP.BUSTE
      );
    },
    showBusteOpenedOffers() {
      return (
        this.roundStep &&
        this.roundStep.type == Constants.ROUND_STEP.BUSTE &&
        !this.bustaChiusaProcessing &&
        this.numeroBusteConOfferta > 0
      );
    },
    numeroBusteConOfferta() {
      return this.bustaChiusaOfferteOrdinate.filter(
        (off) => off.o > Constants.OFFERTA.PASSO
      ).length;
    },
    showApriBuste() {
      return (
        this.admin &&
        this.offerteCompletate &&
        this.roundStep.type == Constants.ROUND_STEP.OFFERTE
      );
    },
    waitingAdminOpenBuste() {
      return (
        !this.admin &&
        this.offerteCompletate &&
        this.roundStep.type == Constants.ROUND_STEP.OFFERTE
      );
    },
    showEsitoBusteText() {
      return (
        this.offerteCompletate &&
        this.roundStep.type == Constants.ROUND_STEP.BUSTE &&
        this.bustaChiusaEsitoText
      );
    },
    bustaChiusaEsitoText() {
      return this.getBustaChiusaEsito().text;
    },
    waitingOtherParticipants() {
      return (
        !this.offerteCompletate &&
        ((this.active && this.offerto) || (this.admin && !this.active))
      );
    },
    showOfferActions() {
      return (
        !this.bustaChiusaProcessing &&
        this.active &&
        !this.offerto &&
        !this.passato
      );
    },
    showPassatoHint() {
      return !this.bustaChiusaProcessing && this.passato;
    },
    showWaitingOtherParticipants() {
      return !this.bustaChiusaProcessing && this.waitingOtherParticipants;
    },
  },
  methods: {
    async avanti() {
      this.loading = true;
      await this.wait(1000);
      await this.eseguiBustaChiusaEsito();
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.panoramica-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.panoramica-buste-menu {
  min-width: 320px;
  max-height: 260px;
  overflow-y: auto;
}

.panoramica-buste-offerta-time {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.panoramica-actions-esito {
  max-width: min(420px, 50vw);
  font-size: 11px;
  line-height: 1.2;
  color: #fff;
}

.panoramica-actions-waiting {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;
}

.panoramica-busta-hint {
  font-size: 11px;
  line-height: 1.2;
  color: #fff;
}
</style>
